import React from 'react';
import './classes/PageSidebarBlocks.css';
import { configData } from "../config";
import { liveCopyOrHide } from './liveImageFallback';
import AgentAthleteSearch from './AgentAthleteSearch';

// Blocks the live site places in the side columns of some basic pages, with their content typed
// into the block (Drupal custom blocks 138, 75, 152, 160, 130, 122 and 128; 129 under the
// content). The pictures are on the
// live site, which has them all (the Drupal copy lacks the GI Bill block's). Live
// shows these pages without sidebars (body class "no-sidebars", the basic pages'
// text styles) but with its right column (region sidebar-third) holding the blocks, under the
// content on phones (Page.js keeps the text styles and Page.css adds the column once something is
// in it: these blocks, or the testimonials and success stories placed on the page); Alumni
// Discount and the alumni form's thank-you page also have a left column.
const files_url = configData.DRUPAL_LIVE_DOMAIN_URL + '/sites/default/files/';

// Block 138's Emeritus Mentors, typed into the block on live
const EMERITUS_MENTORS = [
    { name: 'Greg Hylton', user: 'greg-hylton', picture: 'styles/mentor_block_crop/public/pictures/picture-1982-1548762129.jpg',
      remembering: 'celebrating-greg-hylton', years: 'Remembering Greg Hylton, 1968 - 2020', role: 'Emeritus Mentor for Sports Sales and Marketing' },
    { name: 'Tom Leip', user: 'tom-leip', picture: 'styles/mentor_block_crop/public/pictures/picture-1984-1548762441.jpg',
      remembering: 'remembering-tom-leip', years: 'Remembering Tom Leip, 1956 - 2021', role: 'Emeritus Mentor for Sports Sales and Marketing' },
    { name: 'Mark Warkentien', user: 'mark-warkentien', picture: 'styles/mentor_block_crop/public/pictures/picture-1960-1484674840.jpg',
      remembering: 'remembering-mark-warkentien', years: 'Remembering Mark Warkentien, 1953 - 2022', role: 'Emeritus Mentor for Basketball GM & Scouting' },
    { name: 'Vassili Cremanzidis', user: 'vassili-cremanzidis', picture: 'medium_Pic_0.jpeg',
      remembering: 'remembering-vassili-cremanzidis', years: 'Remembering Vassili Cremanzidis, 1989 - 2026', role: 'Emeritus Mentor for Soccer Scouting and Management' },
];

// Block 138 (Our Staff): the Global Ambassadors button and the Emeritus Mentors
const StaffBlock = () => (
    <div id="block-block-138" className="page-sidebar-block">
        <div style={{ width: '100%' }}><a className="global_ambassador" href="/program/global-ambassadors" style={{ fontSize: '18px' }}>View Global Ambassadors</a></div>
        <div id="block-views-mentors-block" className="page-sidebar-block__mentors">
            <h2 className="page-sidebar-block__title">Emeritus Mentors</h2>
            <ul className="mentors-wrapper">
                {EMERITUS_MENTORS.map((mentor) => (
                    <li key={mentor.user}>
                        <div className="views-field-picture"><img src={files_url + mentor.picture} width="193" height="158" alt="" onError={liveCopyOrHide} /></div>
                        <div className="views-field-field-last-name"><a href={'/users/' + mentor.user}>{mentor.name}</a></div>
                        <ul className="views-field-field-mentor-biography">
                            <li><a href={'/' + mentor.remembering}><span style={{ color: '#0099ff' }}>{mentor.years}</span></a></li>
                            <li>{mentor.role}</li>
                        </ul>
                    </li>
                ))}
            </ul>
        </div>
    </div>
);

// Alumni Discount's pictures: block 75 in the left column on wider screens, block 152 (the same
// pictures) at the bottom of the right column from 600px down
const ALUMNI_DISCOUNT_PICTURES = [6, 8, 2, 3, 4, 7, 1, 5, 9, 10].map((n) => 'alumni_discount_image_' + n + '.jpg');
const AlumniPictures = ({ id, className }) => (
    <div id={id} className={'page-sidebar-block ' + className}>
        {ALUMNI_DISCOUNT_PICTURES.map((file) => <p key={file}><img src={files_url + file} alt="" onError={liveCopyOrHide} /></p>)}
    </div>
);

// Block 160 (GI Bill): the VA seal (after the spaces typed before it on live), Fort Hays State and
// SMWW, and the GI Bill trademark note
const GiBillBlock = () => (
    <div id="block-block-160" className="page-sidebar-block page-sidebar-block--pictures">
        <p>&nbsp; &nbsp;<a href="https://www.benefits.va.gov/gibill"><img alt="U.S. Department of Veterans Affairs – GI Bill®" src={files_url + 'department-of-veterans-affairs-logo-vector-11574127616d4jlqdfq0a_0.png'} style={{ width: '193px', height: '180px' }} onError={liveCopyOrHide} /></a></p>
        <p><a href="https://www.fhsu.edu/"><img alt="Fort Hays State University" src={files_url + '2018/FHSU-%2B-SMWW-1200px_0_0.png'} style={{ width: '300px', height: '103px' }} onError={liveCopyOrHide} /></a></p>
        <p><a href="/"><img alt="Sports Management Worldwide (SMWW)" src={files_url + '2018/smwwglobe_new.png'} style={{ width: '256px', height: '214px' }} onError={liveCopyOrHide} /></a></p>
        <p className="page-sidebar-block__gi-bill-note"><em><strong>GI Bill® is a registered trademark of the U.S. Department of Veterans Affairs (VA).</strong></em></p>
    </div>
);

// Block 130 (Earn College Credit): three pictures
const CollegeCreditBlock = () => (
    <div id="block-block-130" className="page-sidebar-block page-sidebar-block--pictures">
        <p><img alt="" src={files_url + 'the-benefits-of-earning-college-credit-in-high-school.jpg'} style={{ width: '280px', height: '146px' }} onError={liveCopyOrHide} /></p>
        <p><img alt="" src={files_url + 'college%20credit%20image.jpg'} style={{ width: '280px', height: '210px' }} onError={liveCopyOrHide} /></p>
        <p><img alt="" src={files_url + 'college%20credit%20image%201.png'} style={{ width: '280px', height: '373px' }} onError={liveCopyOrHide} /></p>
    </div>
);

// Block 122 (the referral pages): SMWW's social media, a column of icons
const SOCIAL_LINKS = [
    ['https://www.instagram.com/sportsmanagementworldwide/', 'instagram.png'],
    ['https://www.tiktok.com/login/', 'tiktok.png'],
    ['https://twitter.com/SMWW', 'twitter.png'],
    ['https://www.youtube.com/c/SportsManagementWorldwide', 'youtube.png'],
    ['https://www.facebook.com/SportsManagementWorldwide/', 'facebook.png'],
    ['https://www.linkedin.com/school/sports-management-worldwide/', 'linkedin%20logo.png'],
];
const SocialBlock = () => (
    <div id="block-block-122" className="page-sidebar-block">
        <div className="scm_logos">
            {SOCIAL_LINKS.map(([href, icon]) => (
                <p key={icon}><a href={href} target="_blank" rel="noreferrer"><img className="media_icon" src={files_url + icon} style={{ width: '100px' }} alt="" onError={liveCopyOrHide} /></a></p>
            ))}
        </div>
    </div>
);

// Our Soccer Team (/sports/soccer/directors), the one agency page shown as a basic page here: live's
// Agent & Athlete Search, block 128 at the top of the right column and block 129 (the same search)
// under the content. The page's own styles show 129 in place of 128 from 650px down.
const AgentAthleteSearchBlock = () => (
    <div id="block-block-128" className="page-sidebar-block agent-athlete-search-block">
        <h2>Agent &amp; Athlete Search</h2>
        <AgentAthleteSearch id="agent_athlete_quick_search_wgt_desktop" />
    </div>
);
const AgentAthleteSearchContentBlock = () => (
    <div id="block-block-129" className="page-sidebar-block agent-athlete-search-block">
        <h2>Agent &amp; Athlete Search</h2>
        <AgentAthleteSearch id="agent_athlete_quick_search_wgt" />
    </div>
);

// Which page shows which block, where: "right" at the top of the right column, "right-end" under
// its views blocks, "left" in the left column, "content-end" under the content
const BLOCKS = {
    81: { right: StaffBlock },
    823: { left: () => <AlumniPictures id="block-block-75" className="left_side_desktop" />,
           'right-end': () => <AlumniPictures id="block-block-152" className="right_side_mobile" /> },
    // The alumni form's thank-you page (/alumni-information/thank-you): the same columns as Alumni Discount
    207698: { left: () => <AlumniPictures id="block-block-75" className="left_side_desktop" />,
              'right-end': () => <AlumniPictures id="block-block-152" className="right_side_mobile" /> },
    824: { right: GiBillBlock },
    40: { right: CollegeCreditBlock },
    254318: { right: SocialBlock },
    243271: { right: SocialBlock },
    1111: { right: AgentAthleteSearchBlock, 'content-end': AgentAthleteSearchContentBlock },
};

const PageSidebarBlocks = ({ page, position }) => {
    const Block = page?.type === 'page' && BLOCKS[Number(page?.nid)]?.[position];
    return Block ? <Block /> : null;
};

export default PageSidebarBlocks;
